import React, { createContext, useState, useEffect } from "react";
import { ShowToast, Severty } from "../helper/toast";
import apiPath from "../constants/apiPath";
import apiClient from "../helper/apiClient";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [session, setSession] = useState({ token: null });
  const [userProfile, setUserProfile] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let token = localStorage.getItem("token");
    if (!token) return;
    const userRaw = localStorage.getItem("user");
    if (userRaw) {
      const user = JSON.parse(userRaw);
      setUserProfile(user);
    }
    setIsLoggedIn(true);
    setSession({ token: token });
  }, []);

  useEffect(() => {
    if (!userProfile) return;
  }, [userProfile]);

  useEffect(() => {
    if (!isLoggedIn) return;
  }, [isLoggedIn]);

  const login = () => {
    setIsLoggedIn(true);
    return;
  };

  // Save remember me credentials before clearing
  const saveRememberMeCredentials = () => {
    const rememberMe = localStorage.getItem("rememberMe");
    const rememberedEmail = localStorage.getItem("remembered_email");
    const rememberedPassword = localStorage.getItem("remembered_password");

    if (rememberMe === "true" && rememberedEmail && rememberedPassword) {
      return {
        rememberMe: true,
        email: rememberedEmail,
        password: rememberedPassword,
      };
    }
    return null;
  };

  // Restore remember me credentials after logout
  const restoreRememberMeCredentials = (credentials) => {
    if (credentials && credentials.rememberMe) {
      localStorage.setItem("rememberMe", "true");
      localStorage.setItem("remembered_email", credentials.email);
      localStorage.setItem("remembered_password", credentials.password);
    }
  };

  const clearSession = (preserveRememberMe = true) => {
    // Save remember me credentials before clearing
    const rememberMeCredentials = preserveRememberMe
      ? saveRememberMeCredentials()
      : null;

    // Clear all session data
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("session_id");

    // Clear old remember me keys if they exist (from previous implementation)
    localStorage.removeItem("lab_email");
    localStorage.removeItem("ouUsippetc8S4Ry");

    // Restore remember me credentials if they existed
    if (rememberMeCredentials) {
      restoreRememberMeCredentials(rememberMeCredentials);
    } else if (!preserveRememberMe) {
      // Only clear remember me if explicitly requested
      localStorage.removeItem("rememberMe");
      localStorage.removeItem("remembered_email");
      localStorage.removeItem("remembered_password");
    }
  };

  const logout = async () => {
    try {
      const refresh = localStorage.getItem("refreshToken");
      const sessionId = localStorage.getItem("session_id");
      const token = localStorage.getItem("token");
      setLoading(true);

      const response = await apiClient.post(
        `${apiPath.logout}`,
        {
          refresh: refresh,
          session_id: sessionId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token ? `Bearer ${token}` : undefined,
          },
        },
      );

      if (response.status === 200) {
        ShowToast("Logout Successfully", Severty.SUCCESS);
      }
    } catch (error) {
      console.log("Error occured while logout admin", error);
    } finally {
      // Still proceed with logout even if API fails
      // } finally {
      //   setLoading(false);
      //   // Clear session but preserve remember me credentials
      //   clearSession(true);

      //   // Reset auth state
      //   setIsLoggedIn(false);
      //   setUserProfile(null);
      //   setSession({ token: null });

      //   // Use window.location for redirect instead of useNavigate
      //   // window.location.href = "/login";
      // }
      setLoading(false);

      // Clear session but preserve remember me credentials
      clearSession(true);

      // Redirect immediately
      window.location.replace("/login");
    }
  };

  // New method to clear everything including remember me (for when user explicitly unchecks)
  const fullLogout = async () => {
    try {
      const refresh = localStorage.getItem("refreshToken");
      const sessionId = localStorage.getItem("session_id");
      const token = localStorage.getItem("token");
      setLoading(true);

      const response = await apiClient.post(
        `${apiPath.logout}`,
        {
          refresh: refresh,
          session_id: sessionId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token ? `Bearer ${token}` : undefined,
          },
        },
      );

      if (response.status === 200) {
        ShowToast("Logout Successfully", Severty.SUCCESS);
      }
    } catch (error) {
      console.log("Error occured while logout admin", error);
      // } finally {
      //   setLoading(false);
      //   // Clear everything including remember me
      //   clearSession(false);

      //   // Reset auth state
      //   setIsLoggedIn(false);
      //   setUserProfile(null);
      //   setSession({ token: null });

      //   // Use window.location for redirect instead of useNavigate
      //   // window.location.href = "/login";
      // }
    } finally {
      setLoading(false);

      // Clear session but preserve remember me credentials
      clearSession(false);

      // Redirect immediately
      window.location.replace("/login");
    }
  };

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn,
        setIsLoggedIn,
        session,
        setSession,
        userProfile,
        setUserProfile,
        login,
        logout,
        fullLogout,
        clearSession,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
